
import { defineComponent } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '~/assets/util'

export default defineComponent({
  props: {
    eventDate: { type: [String, Date], required: false, default: undefined },
    isEducationCustomer: { type: Boolean, required: false, default: false },
    remaining: { type: Number, required: false, default: 0 },
    educationTixSale: { type: Object, required: false, default: () => ({}) },
    url: { type: String, required: false, default: undefined },
  },
  setup({ educationTixSale }) {
    const { isBookable } = educationTixSale

    return {
      ...setupTranslationPrefixer('Education', 'InfoRow'),
      isBookable,
    }
  },
})
